module.exports = __webpack_public_path__ + "img/351-f8deea.png";